export const WORKPLACE = { en: 'Workplace', th: 'สถานที่ทำงาน' }

export const RENTAL_BUDGET = { en: 'Rental budget', th: 'งบประมาณการเช่า' }

export const BEDROOM = { en: 'Bedroom', th: 'ห้องนอน' }
